// import _ from 'lodash';

const products = {
  loading: false,
  active: '',
  activePage: 0,
  perPage: 60,
  totalPages: null,
  tableView: 'grid',
  list: [],
  filters: {},
  hasActiveFilters: false,
  searchKeyword: '',
  history: [],
  sort: window.defaultSort || null,
}
const ProductsReducer = function (state = products, action) {
  switch (action.type) {
    case 'TOGGLE_PRODUCTS_LOADING': {
      return {
        ...state,
        loading: action.value,
      }
    }
    case 'TOGGLE_ACTIVE_FILTERS': {
      return {
        ...state,
        hasActiveFilters: action.value,
      }
    }
    case 'TOGGLE_FILTER': {
      return {
        ...state,
        filters: action.value,
      }
    }
    case 'SET_PRODUCTS_FILTERS': {
      return {
        ...state,
        filters: action.value,
      }
    }
    case 'SET_PRODUCTS_LIST': {
      return {
        ...state,
        list: action.list,
      }
    }
    case 'SET_PRODUCTS_SCROLLABLE_LIST': {
      return {
        ...state,
        list: {
          ...state.list,
          [action.blockID]: action.list,
        },
      }
    }
    case 'SET_ACTIVE_PAGE': {
      return {
        ...state,
        activePage: action.value,
      }
    }
    case 'SET_PER_PAGE': {
      return {
        ...state,
        perPage: action.value,
      }
    }
    case 'SET_TOTAL_PAGES': {
      return {
        ...state,
        totalPages: action.value,
      }
    }
    case 'SET_TABLE_VIEW': {
      return {
        ...state,
        tableView: action.value,
      }
    }
    case 'SET_SORT': {
      return {
        ...state,
        sort: action.value,
      }
    }
    case 'UPDATE_PRODUCTS_SEARCH': {
      return {
        ...state,
        searchKeyword: action.value,
      }
    }
    case 'UPDATE_PRODUCTS_LIST': {
      let newList = {}
      Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.list[key], ...value }))
      return {
        ...state,
        list: {
          ...state.list,
          ...newList,
        },
      }
    }
    case '@@router/LOCATION_CHANGE': {
      const { key } = action.payload.location
      let newHistory = [...state.history]

      if (key && state.history.indexOf(key) === -1) {
        newHistory.push(key)
      }
      return {
        ...state,
        history: newHistory,
      }
    }
    default: {
      return state
    }
  }
}

export default ProductsReducer
